import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { styled } from '@linaria/react';
import { SelectedElementType } from 'components/Accommodation/DateGuestInput/ReviewsTrackClick';
import { ReviewCommentWrapper } from 'components/Reviews/ReviewCommentWrapper';
import { showGuestReviewsOverlay } from 'modules/overlay/actions';
import { Button } from '@daedalus/atlas/Button';
import { Divider } from '@daedalus/atlas/Divider';
import { Box } from '@daedalus/atlas/helpers/Box';
import { Text } from '@daedalus/atlas/Text';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity } from '@daedalus/core/src/analytics/types/Events';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
import { getLengthOfStay } from '@daedalus/core/src/utils/date';
import { LoadMoreReviews, ReviewSource } from '@daedalus/shared/src/search/ReviewComment';
import { Review } from '@findhotel/sapi';
import { reviewMessages } from '../ReviewMessages';
interface Props {
  reviewsData: Review[];
  noMoreReviews: boolean;
  mountedOnOverlay?: boolean;
  onLoadMore: () => void;
  sourceComponent: string;
  searchKeywords?: string[];
  reviewsAvailable?: number;
}
const ReviewWrapper = /*#__PURE__*/styled('div')({
  name: "ReviewWrapper",
  class: "r3dyk85",
  propsAsIs: false
});
export const GuestReviews: React.FC<Props> = ({
  reviewsData,
  noMoreReviews,
  mountedOnOverlay = false,
  onLoadMore,
  sourceComponent,
  searchKeywords,
  reviewsAvailable
}) => {
  const {
    formatMessage
  } = useIntl();
  const dispatch = useDispatch();
  const handleReadAllReviews = useCallback(() => {
    dispatch(trackEvent({
      category: Category.User,
      entity: Entity.ReviewDetails,
      action: Action.Clicked,
      payload: {
        selectedElement: SelectedElementType.ReadAllReviews
      }
    }));
    dispatch(showGuestReviewsOverlay());
  }, [dispatch]);
  const onSourceLogoClick = () => {
    dispatch(trackEvent({
      category: Category.User,
      entity: Entity.ReviewDetails,
      action: Action.Clicked,
      payload: {
        selectedElement: SelectedElementType.ReviewLogo
      }
    }));
  };
  const showReadAllReviewsButton = useMemo(() => {
    if (mountedOnOverlay) return false;
    return reviewsData?.length > 4;
  }, [mountedOnOverlay, reviewsData]);
  const reviews = useMemo(() => {
    if (showReadAllReviewsButton || !mountedOnOverlay) {
      return reviewsData.slice(0, 5);
    }
    return reviewsData;
  }, [showReadAllReviewsButton, reviewsData, mountedOnOverlay]);
  return <>
      {searchKeywords?.length > 0 && reviewsAvailable && <Box paddingBottom="s500">
          <Text variant="titleM">
            {formatMessage(reviewMessages.reviewSectionCount, {
          count: reviewsAvailable
        })}
          </Text>
        </Box>}
      <ReviewWrapper>
        {reviews.map((review, index) => <React.Fragment key={index}>
            {index > 0 && <Divider />}
            <ReviewCommentWrapper reviewText={review.text} reviewLanguage={review.language} reviewerScore={review.reviewerScore} reviewDate={review.reviewDate} lengthOfStay={getLengthOfStay(review.checkIn, review.checkOut)} reviewerName={review.reviewerName} onSourceLogoClick={onSourceLogoClick} SourceLogoSlot={review?.reviewSource && <ReviewSource providerCode={review.reviewSource} />} reviewSource={review.reviewSource} truncatedContentLines={mountedOnOverlay ? 5 : 3} searchKeywords={searchKeywords} />
          </React.Fragment>)}

        {mountedOnOverlay && <LoadMoreReviews noMoreReviews={noMoreReviews} onLoadMore={onLoadMore} sourceComponent={sourceComponent} />}

        {showReadAllReviewsButton && <Box display="flex" flexDirection="column" alignItems="center">
            <Box paddingTop="s300">
              <Button variant="secondary" size="xl" onClick={handleReadAllReviews}>
                <FormattedMessageWrapper id="readAllReviews" defaultMessage="Read all reviews" />
              </Button>
            </Box>
          </Box>}
      </ReviewWrapper>
    </>;
};

require("./GuestReviews.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./GuestReviews.tsx");